import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {WEB_PREFERENCE_CENTER} from '@/consts/tnc/tncTypes';
import routerService from '@/services/route/routerService';
import {makeSelectAcceptedTncByType, makeSelectTncByType} from '@/state/selectors/consumer';
import {selectIsAllNonMandatoryTermsReviewed} from '@/state/selectors/consumerAggregatedSettings';

import PreferenceCenter from './PreferenceCenter/PreferenceCenter';

const TncDetailsPreferenceCenter = ({onApproved}) => {
    const isAllNonMandatoryTermsReviewed = useSelector(selectIsAllNonMandatoryTermsReviewed);
    const dataCollectionTnc = useSelector(makeSelectTncByType(WEB_PREFERENCE_CENTER));
    const acceptedTermsOfUse = useSelector(makeSelectAcceptedTncByType(WEB_PREFERENCE_CENTER));
    const {titleDescription: newTitleDescription, legals = []} = dataCollectionTnc || {};
    const {titleDescription: acceptedTitleDescription} = acceptedTermsOfUse || {};
    const titleDescription = dataCollectionTnc ? newTitleDescription : acceptedTitleDescription;
    const acceptedLegals = acceptedTermsOfUse?.legals;
    const acceptedLegalsFiltered = useMemo(() => {
        const result = acceptedLegals
            ? acceptedLegals.filter((al) => !legals.some((l) => l.code.toLowerCase() === al.code.toLowerCase()))
            : [];

        return result;
    }, [acceptedLegals]);

    const handleBack = isAllNonMandatoryTermsReviewed ? routerService.goBack : undefined;

    return (
        <PreferenceCenter
            legals={legals}
            acceptedLegals={acceptedLegalsFiltered}
            onApproved={onApproved}
            isEnableAllAvailable={!isAllNonMandatoryTermsReviewed}
            description={titleDescription}
            onBack={handleBack}
        />
    );
};

export default TncDetailsPreferenceCenter;
